import React from "react";

import { ReactTableServerSide } from "../../ReactTableServerSide";
import Popup from "reactjs-popup";
import auth from "../../../Auth";
import { fileAll, fileViewCols } from "../../../apis";

import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Typography } from "@material-ui/core";

import { CsvButton } from "../../CsvButton";
import GPAP_BUTTON, {
  GPAP_BUTTON_LIGHT,
} from "../../../../gpap-lib/Button_Collection";

import ShowDownloadLinks from "./ShowDownloadLinks";
import ShowFileDeletion from "./ShowFileDeletion";

import Box from "@material-ui/core/Box";

import {
  toggleRow,
  isSelected,
  updateTable,
  createIconOwner,
} from "../../components/TableMethods.js";

import CustomizeColumns from "../datasets-view/CustomizeColumns";

const { config } = window;

// TODO
// test if all needed config are there:
// file_view_fields, api_endpoint
// if not throw error and render fallback

// FIXME
// visibility is not working
// the colum is empty

// TODO
// add tests for file deletion
// add these changes for enabling file deletion to the development branch

// TODO
// Change the styling of the URL in the download table
// if URL = download forbidden, then show no link but red text
// + remove the COPY URL Button


export class FilesView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // headers: config.filesViewHeaders,
      headers: [],
      files: [],
      // actionSelected: "unselected",
      // filters: [{ title: "BY OWNER", values: ["All", "admin", "cnag-gut"] }],
      // search: "",

      pagination: {
        loadData: true,
        page: 0,
        pages: 0,
        pageSize: 100,
        totalItems: 0,
        filtered: [],
        sorted: [],
      },
      popupErrors: "",
      csvData: [],
      csvFileName: "",
      selected: [],
      selectedFields: {},
      selectAll: 0,
      columnsShown: [],
      defaultColumnsBool: true,
      urlsMapping: {},
      defaultFilter: [],
      initialized: false,
    };

    this.getCsvData = this.getCsvData.bind(this);
    this.csvLink = React.createRef();

    //needed for CustomizeColumns
    this.updateColumns = this.updateColumns.bind(this);

    this.handleFileDeleteConfirmed = this.handleFileDeleteConfirmed.bind(this);
  }

  /* Define a method to control Row Clicks*/
  // TODO: Unexpected empty arrow function.
  onRowClick = (state, rowInfo, column, instance) => ({
    onClick: (e) => {},
  });

  async getViewCols(api) {
    let jsonData = {};

    // const query = {
    //   api,
    // };

    try {
      const response = await fileViewCols(
        auth.getToken(),
        config.api_endpoint
        // `${api}`,
        // query
      );
      jsonData = await response.json();

      return jsonData[0].headers;
    } catch (error) {}
  }

  async componentDidMount() {
    if (auth.tokenExpired()) {
      this.setState({
        popupErrors: "Session expired. Please login again",
      });
      return;
    }

    const tableHeaders = await this.getViewCols("files");
    this.setState({ headers: tableHeaders });

    // if redirected from dataset view
    // take the selected dataset's owners/ids
    // and use it to pre set the filter
    if (this.props.location.state) {
      

      const { selectedDatasets } = this.props.location.state;

      const ids = new Set(selectedDatasets.map((d) => d.dataset_id));
      const owners = new Set(selectedDatasets.map((d) => d.owner));

      this.setState({
        defaultFilter: [
          {
            id: "dataset_id",
            value: [...ids].join(),
          },
          {
            id: "checkbox",
            value: [...owners].join(),
          },
        ],
        initialized: true,
      });
    } else {
      this.setState({ initialized: true });
    }
    // this.setState({ headers: stateHeaders });
  }

  //   const newSelected = [];
  //   //Update all checkboxes as checked
  //   if (selectAll === 0) {
  //     for (const row of rows) {
  //       newSelected.push(row);
  //     }
  //   }
  //
  //   return newSelected;
  // };

  /*Method to call API Endpoint to get React Table Data*/
  loadTableData = (state, instance) => {
    this.setState({ loadData: true });

    /*Call API Endpoint*/
    const data_query = {
      page: state.page + 1,
      pageSize: state.pageSize,
      // fields: fields,
    };
    /*Check filtered Criteria*/
    if (state.filtered) {
      data_query.filtered = state.filtered.map((item) => ({
        id: item.id,
        value: item.value,
      }));
    }
    /*Check sorted Criteria*/
    if (state.sorted) {
      data_query.sorted = state.sorted;
    }
    /* Call POST Data*/
    // return file(
    //   auth.getToken(),
    //   config.api_endpoint,
    //   "view",
    //   JSON.stringify(data_query)
    // )

    // if (this.props.location.state) {
    //   const { selectedDatasets } = this.props.location.state;

    //   const ids = new Set(selectedDatasets.map((d) => d.dataset_id));
    //   const owners = new Set(selectedDatasets.map((d) => d.owner));

    //   defaultFilter = [
    //     {
    //       id: "dataset_id",
    //       value: [...ids].join(),
    //     },
    //     {
    //       id: "checkbox",
    //       value: [...owners].join(),
    //     },
    //   ];

      // check if default filter is the same as data_query.filter
      // if (defaultFilter !== data_query.filtered) {
      //   data_query.filtered = [
      //     {
      //       id: "dataset_id",
      //       value: [...ids].join(),
      //     },
      //     {
      //       id: "checkbox",
      //       value: [...owners].join(),
      //     },
      //   ];
    // }

    return (
      fileAll(auth.getToken(), config.api_endpoint, JSON.stringify(data_query))
        // return fileAll(
        //   auth.getToken(),
        //   config.api_endpoint,
        //   "view",
        //   JSON.stringify(data_query)
        // )
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            files: data.items,
            pagination: {
              page: data._meta.page,
              pages: data._meta.total_pages,
              pageSize: data._meta.page_size,
              totalItems: data._meta.total_items,
              // fields: fields,
              filtered: state.filtered,
              sorted: state.sorted,
              loadData: false,
            },
          });
        })
    );
  };

  getData = async (data_query, filtered, sorted) => {
    /* Call POST Data*/
    fileAll(auth.getToken(), config.api_endpoint, JSON.stringify(data_query))
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          files: data.items,
          pagination: {
            page: data._meta.page,
            pages: data._meta.total_pages,
            pageSize: data._meta.page_size,
            totalItems: data._meta.total_items,
            // fields: fields,
            filtered,
            sorted,
            loadData: false,
          },
        });
      });
  };

  getData = async (data_query, filtered, sorted) => {
    /* Call POST Data*/
    fileAll(auth.getToken(), config.api_endpoint, JSON.stringify(data_query))
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          files: data.items,
          pagination: {
            page: data._meta.page,
            pages: data._meta.total_pages,
            pageSize: data._meta.page_size,
            totalItems: data._meta.total_items,
            // fields: fields,
            filtered,
            sorted,
            loadData: false,
          },
        });
      });
  };

  //
  // How to not show original.id in the react table view
  // 1. you get the data,
  // 2. you create a temporary my_id for all your objects ( make a copy of the objects)
  // 3. you use this id in your React Table to handle the select
  // 4. when pushing, get rid of this new my_id. you can user original.my_id instead

  // Other idea
  // https://codesandbox.io/s/03x3r0vx1l
  // https://github.com/tannerlinsley/react-table/issues/1804
  // https://codesandbox.io/s/relaxed-night-y5gcl?file=/src/App.js
  // https://github.com/jbetancur/react-data-table-component/issues/708
  // https://github.com/tannerlinsley/react-table/discussions/1971

  getDataColumnTable() {
    const toggleSelectAll = (selectAll, rows) => {
      const newSelected = [];
      //Update all checkboxes as checked
      if (selectAll === 0) {
        for (const row of rows) {
          newSelected.push(row);
        }
      }
      return newSelected;
    };

    //add selection checkbox
    const columnCheckbox = {
      id: "checkbox",
      Header: (x) => (
        <span>
          Select{" "}
          <input
            data-cy="select-all-checkbox"
            type="checkbox"
            className="checkbox"
            checked={this.state.selectAll === 1}
            ref={(input) => {
              if (input && this.state.selectAll === 2) {
                if (this.state.selected.length === 0) {
                  input.checked = false;
                } else {
                  input.indeterminate = true;
                }
              }
            }}
            onChange={() =>
              this.setState({
                selected: toggleSelectAll(this.state.selectAll, [
                  ...this.state.files,
                ]),
                selectAll: this.state.selectAll === 0 ? 1 : 0,
              })
            }
          />
        </span>
      ),
      Cell: ({ original, index }) => {
        return (
          <input
            data-cy={`select-row-checkbox-${index}`}
            type="checkbox"
            className="checkbox"
            checked={isSelected(original.id, this.state.selected)}
            onChange={() =>
              this.setState({
                selected: toggleRow(original, this.state.selected),
                selectAll: 2,
              })
            }
          />
        );
      },
      filterable: false,
      sortable: false,
      width: 80,

      // hijack the filter method to 
      // add a button which clears all filters
      // Filter: ({ filter, onChange }) => (
        
      //   <div>
      //     <button
      //       onClick={() => {
      //         onChange("");
      //       }}
      //     >
      //       Clear
      //     </button> 
      //   </div>


        // <select
        //   onChange={(event) => onChange(event.target.value)}
        //   style={{ width: "100%" }}
        //   value={filter ? filter.value : "all"}
        //   data-cy="healthyControllsIncluded-dropdown"
        // >
        //   <option value="">all</option>
        //   <option value="True">True</option>
        //   <option value="False">False</option>
        // </select>
      // )
    };
    const columns = [columnCheckbox, createIconOwner()];

    // FIXME
    // unnecessary renders:
    // 1. render this.state.files.length == 0 (loadTableData is not finished)
    // 2. render this.state.files.length == 0 (loadTableData is not finished)
    // 3. render this.state.files.length > 0 (loadTableData is finished)

    // FIXME
    // it's dangerous to directly pass this.state.files to a function.
    // rather pass a copy of the array
    // [...this.state.files]

    return updateTable(
      columns,
      this.state.columnsShown,
      this.state.headers,
      this.state.files,
      this.state.defaultColumnsBool
    );
  }

  closeModal = () => {
    if (this.state.popupErrors === "Session expired. Please login again") {
      auth.user.keycloak.logout();
    }
    this.setState({ popupErrors: "" });
  };

  /*Handler Action Select click*/
  // handleSelectChange = (event) => {
  //   this.setState({ actionSelected: event.target.value });
  // };

  getCsvData = async (headers) => {
    /*Get All Data to be printed to CSV Files*/
    const data_query = {
      page: 1,
      pageSize: this.state.pageSize,
      // fields: fields,
    };
    /*Check filtered Criteria*/
    if (this.state.filtered) {
      data_query.filtered = this.state.filtered.map((item) => ({
        id: item.id,
        value: item.value,
      }));
    }
    /*Check sorted Criteria*/
    if (this.state.sorted) {
      data_query.sorted = this.state.sorted;
    }

    let getData = true;
    const allItems = [];
    /*Get All Data*/
    while (getData) {
      /*Call POST Data*/

      await fileAll(
        auth.getToken(),
        config.api_endpoint,
        JSON.stringify(data_query)
      )
        .then((response) => response.json())
        .then((data) => {
          allItems.push(...data.items);
          if (data_query.page < data._meta.total_pages) {
            getData = true;
            data_query.page = data_query.page + 1;
          } else getData = false;
        });
    }
    //Build data for CSV
    const data = [];
    for (let item of allItems) {
      const row = {};
      //1. Loop Headers
      for (let header of this.state.headers) {
        row[header.key] =
          typeof item[header.key] === "boolean"
            ? item[header.key].toString()
            : item[header.key];
      }
      //2. Add row to data
      data.push(row);
    }

    const today = new Date().toISOString().slice(0, 10);
    this.setState(
      { csvData: data, csvFileName: `${today}_file_list.csv` },
      () => {
        // click the CSVLink component to trigger the CSV download
        this.csvLink.current.link.click();
      }
    );
  };

  updateColumns(columns) {
    //needed for CustomizeColumns
    this.setState({ columnsShown: columns });
    this.setState({ defaultColumnsBool: false });
  }

  handleFileDeleteConfirmed = () => {
    const { page, pageSize, filtered, sorted } = this.state.pagination;

    const data_query = {
      page,
      pageSize,
      filtered,
      sorted,
    };
    this.getData(data_query, filtered, sorted);

    // after deletion the file selected state should be reseted
    this.setState({ selected: [] });
  };

  // use this to show the Download URLs
  showSelectedFiles = () => (
    <div className={"actionContainer"}>
      <span style={{ marginLeft: "10px" }}>
        Files Selected: {Object.keys(this.state.selected).length}
      </span>
      {Object.keys(this.state.selected).length > 0 ? (
        // Open Dialog
        <>
          <ShowDownloadLinks selected={this.state.selected} />
          <ShowFileDeletion
            selected={this.state.selected}
            onConfirm={this.handleFileDeleteConfirmed}
          />
        </>
      ) : (
        // Buttons are set to disabled if no row is selected
        <>
          <GPAP_BUTTON disabled={true} style={{ marginLeft: "10px" }}>
            Download Files
          </GPAP_BUTTON>
          <GPAP_BUTTON
            disabled={true}
            style={{ marginLeft: "10px", background: "darkred" }}
          >
            Delete Files
          </GPAP_BUTTON>
        </>
      )}
    </div>
  );

  render() {
    /*Show popip in case an error with the loggin occurs*/
    if (this.state.popupErrors) {
      return (
        <Popup open={true} closeOnDocumentClick onClose={this.closeModal}>
          <div>
            <button className="close" onClick={this.closeModal}>
              {" "}
              &times;{" "}
            </button>
            <div className="page-header">
              {" "}
              <h1> Logging error. </h1>{" "}
            </div>
            <div className="alert alert-warning">{this.state.popupErrors} </div>
          </div>
        </Popup>
      );
    }
    // TODO
    // suggestion by Alberto add this to ComponentDidMount
    const columnsDataTable = this.getDataColumnTable();
    return (
      <div className={"mainContent"}>
        <Typography variant={"h5"} align={"center"}>
          {" "}
          List of Uploaded Files{" "}
        </Typography>

        <Box p={2}>
          <Box p={0} style={{ float: "left" }}>
            <CustomizeColumns
              // type={"files"}
              headers={this.state.headers}
              updateColumns={this.updateColumns}
            />
            <CsvButton
              getCsvData={this.getCsvData}
              csvData={this.state.csvData}
              headersCsv={this.state.headers}
              nameFile={this.state.csvFileName}
              csvLink={this.csvLink}
            />
            {/* Adds select table columns - NOT working */}
            {this.showSelectedFiles()}
          </Box>
        </Box>
        {this.state.initialized ? (
          <ReactTableServerSide
            headers={this.state.headers}
            columns={columnsDataTable[0]}
            data={columnsDataTable[1]}
            pagination={this.state.pagination}
            onRowClick={this.onRowClick}
            loadTableData={this.loadTableData}
            loading={this.state.pagination.loadData}
            defaultFiltered={this.state.defaultFilter}
            // TODO get the fields delay info from the backend
            fieldsDelay={["dataset_id","project_id","name"]}
          />
        ) : null}
      </div>
    );
  }
}
